import clsx from 'clsx';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { TableFilter, TableFilterState } from '@eas/common-web';
import { FilterState } from './filter-types';
import { isFilterValueActive } from './filter-utils';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 8,
    marginLeft: 8,
    marginTop: 4,
    padding: 2,
    flex: '1 1 250px',
  },
  labelWrapper: {
    width: '100%',
    borderRadius: 4,
    transition: 'background-color 150ms ease, color 150ms ease',
  },
  labelPadding: {
    paddingLeft: 4,
  },
  activeLabelWrapper: {
    backgroundColor: '#FFC90E', // #0d98ba
    color: '#000',
  },
  fieldWrapper: {
    width: '100%',
    borderRadius: 4,
    transition: 'background-color 150ms ease, box-shadow 150ms ease',
  },
  activeFieldWrapper: {
    backgroundColor: '#e3f2f7',
    boxShadow: 'inset 0 0 0 2px #1f6f8b',
  },
});

interface TableFilterDialogItemProps {
  /**
   * Filter.
   */
  filter: TableFilter;

  /**
   * Filter state.
   */
  state: FilterState;

  /**
   * OnChange handler for filter value.
   */
  onChangeValue: (value: any) => void;

  /**
   * OnChange handler for complex filter value.
   */
  onChangeFilterState: (state: FilterState) => void;

  /**
   * Visibility state
   */
  visible: boolean;
}

export function FilterComponent({
  filter,
  state,
  onChangeValue,
  onChangeFilterState,
  visible,
}: TableFilterDialogItemProps) {
  const classes = useStyles();
  const { FilterComponent } = filter;
  const active = isFilterValueActive(state);

  if (!visible) {
    return <></>;
  }

  return (
    <div
      className={clsx(classes.root, { [classes.activeLabelWrapper]: active })}
    >
      <div
        className={clsx(classes.labelWrapper, {
          [classes.labelPadding]: active,
        })}
      >
        <Typography variant="body1">{filter.label}</Typography>
      </div>
      <div className={clsx(classes.fieldWrapper)}>
        <FilterComponent
          filter={filter}
          disabled={false}
          state={state as TableFilterState}
          value={state.value}
          onChange={onChangeValue}
          onChangeState={onChangeFilterState}
        />
      </div>
    </div>
  );
}
